export default __webpack_public_path__ + "static/media/clienticon.b774af39.png";